import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, output } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "@openng/optimus-ui/select";
import { merge } from "rxjs";

import {
  HardwareAdapterOutputIndex,
  HardwareAdapterOperation,
} from "../../../../../models/api/hardwareAdapterConfigurationDto";
import { SvgIconComponent } from "../../../../../shared/components/svg-icon/svg-icon.component";
import { ButlerV1ConfigurationRowComponent } from "../butler-v1-configuration-row/butler-v1-configuration-row.component";
import {
  HardwareConfigurationOption,
  HardwareConfigurationRow,
  HardwareConfigurationValidity,
} from "../hardware-configuration-form";

import { HardwareAdapterType, HARDWARE_ADAPTER_TYPES } from "../../../../../enums/hardwareAdapterTypes";
@Component({
  selector: "app-hardware-configuration-row",
  standalone: true,
  imports: [ButlerV1ConfigurationRowComponent, ReactiveFormsModule, SelectModule, SvgIconComponent, TranslateModule],
  templateUrl: "./hardware-configuration-row.component.html",
  styleUrl: "./hardware-configuration-row.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HardwareConfigurationRowComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  public readonly row = input.required<HardwareConfigurationRow>();
  public readonly rowNumber = input.required<number>();
  public readonly adapterTypeOptions = input.required<HardwareConfigurationOption<HardwareAdapterType>[]>();
  public readonly operationOptions = input.required<HardwareConfigurationOption<HardwareAdapterOperation>[]>();
  public readonly indexOptions = input.required<HardwareConfigurationOption<HardwareAdapterOutputIndex>[]>();
  public readonly canEdit = input.required<boolean>();
  public readonly removeRequested = output<void>();

  protected readonly hardwareAdapterType = HARDWARE_ADAPTER_TYPES;

  public ngOnInit(): void {
    const row = this.row();
    if (row.kind === "unsupported") {
      return;
    }

    merge(row.form.controls.adapterType.valueChanges, row.form.controls.configuration.valueChanges)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        row.form.controls.validity.setValue({ status: "pending" }, { emitEvent: false });
      });
  }

  protected getValidity(row: HardwareConfigurationRow): HardwareConfigurationValidity | null {
    return row.kind === "supported" ? row.form.controls.validity.value : row.validity;
  }

  // protected getValidityIssueTranslationKeys(validity: HardwareAdapterValidity): string[] {
  //   return [...new Set(validity.issues.map((issue) => this.validityIssueTranslationKeys[issue]))];
  // }
}
